import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { OptionType } from '../../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';

interface Props<T extends FieldValues> {
  control: Control<T>;
  options: OptionType<number | null>[];
  formKey: Path<T>;
  onManagementSelect(value: number | null): void;
}

export function ManagementStyle<T extends FieldValues>({
  control,
  options,
  formKey,
  onManagementSelect,
}: Props<T>) {
  return (
    <>
      <Controller
        control={control}
        name={formKey}
        render={({ field: { value, onChange } }) => {
          return (
            <Select
              isPortal
              value={options.find(option => option.value === value) ?? null}
              options={options}
              onChange={option => {
                onChange(option?.value ?? null);
                onManagementSelect(option?.value ?? null);
              }}
              label="Management Style"
            />
          );
        }}
      />
    </>
  );
}
